import { IAIChatContext } from './interfaces';
import { useControllerData } from '../../main/controllerContext';

export const useAIChatData = (): IAIChatContext => {
  const props = useControllerData();

  return {
    currentChatId: props.currentChatId,
    currentChatPair: props.currentChatPair,
    chat: props.chat,
    messages: props.messages,
    personaSettings: props.personaSettings,
    setCurrentChatId: props.setCurrentChatId,
    createPersonaChat: props.createPersonaChat,
    requestPersonaChat: props.requestPersonaChat,
    sendChatMessage: props.sendChatMessage,
    requestChatMessages: props.requestChatMessages,
    addPersonaPair: props.addPersonaPair,
    getPersonaPair: props.getPersonaPair,
    getPersonaSettings: props.getPersonaSettings,
    queryRecentChatId: props.queryRecentChatId,
  };
};
